import React from "react";

const Dashboard = () => {
  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#f4f4f4",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#333" }}>Dashboard</h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "20px",
          width: "100%",
          maxWidth: "1200px",
          marginTop: "20px",
        }}
      >
        {/* Card 1 */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h3>Total Users</h3>
          <p style={{ fontSize: "24px", color: "#4CAF50" }}>1,200</p>
        </div>

        {/* Card 2 */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h3>Active Sessions</h3>
          <p style={{ fontSize: "24px", color: "#FF9800" }}>342</p>
        </div>

        {/* Card 3 */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h3>Revenue This Month</h3>
          <p style={{ fontSize: "24px", color: "#2196F3" }}>$5,430</p>
        </div>

        {/* Card 4 */}
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h3>New Sign Ups</h3>
          <p style={{ fontSize: "24px", color: "#9C27B0" }}>50</p>
        </div>
      </div>

      {/* Additional content can go here */}
      <div style={{ marginTop: "30px" }}>
        <h2>Latest Activity</h2>
        <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
          <li>New user signed up - 10 minutes ago</li>
          <li>New comment on your post - 1 hour ago</li>
          <li>System update completed - 2 hours ago</li>
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;
